import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';


const routes: CustomRoute = {
	path: '/privacy',
	components: () => [],
	render: (_, children) => children,
	onEnter: async () => {},
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'privacy' */ './component')],
			render: ([Privacy]) => <Privacy />,
			onEnter: async ({ next }) => {
				console.log('on Enter privacy');
				await next();
				console.log('on Enter privacy / end');
			},
		},
	],
};

export default routes;
